import React, { useState, useEffect, useRef, useContext } from 'react'
import { OrderEngineContext } from '../../contexts/OrderEngineContext'
import useAssets from '../../hooks/useAssets'

function OEAsset(props) {
  const { brandID, appParams, getCachedAsset, loadImage } = useContext(OrderEngineContext)
  const { uuid, size, rootMargin = '0px', defaultItemImg = null } = props

  const { assets } = useAssets()

  const [item, setItem] = useState(null)
  const [imgPath, setImgPath] = useState(null)
  const [imgPathXS, setImgPathXS] = useState(null)

  const [defaultSrc, setDefaultSrc] = useState(null)

  const [currentSrc, setCurrentSrc] = useState(null)
  const [loading, setLoading] = useState(true)

  const bigLoading = useRef(true)

  useEffect(() => {
    setDefaultSrc(`${defaultItemImg || appParams?.assets?.defaultItemImg}`)
  }, [appParams, defaultItemImg])

  useEffect(() => {
    if (uuid != null && Object.keys(assets || {})?.length > 0) {
      if (assets[uuid.toUpperCase()] != null) setItem(assets[uuid.toUpperCase()])
      else setItem({ useDefault: true })
    }
  }, [assets, uuid])

  useEffect(() => {
    if (!(item?.useDefault == null && (item == null))) {
      if (item.useDefault) {
        setImgPathXS(defaultSrc)
        setImgPath(defaultSrc)
      } else {
        const src = `https://${item.store}.okeoke.io/brands/${brandID}/assets/${item.uuid.toLowerCase()}`
        const extension = item['extension']
        const _imgPath = `${src}_${size}.${extension}`
        const _imgPathXS = `${src}_${'xs'}.${extension}`

        let cachedAsset = getCachedAsset(item.uuid.toLowerCase() + `_${size}`)
        if(cachedAsset != null) {
          setCurrentSrc(_imgPath)
          bigLoading.current = false
          setLoading(false)
        } else {
          setImgPathXS(_imgPathXS)
          setImgPath(_imgPath)
        }
      }
    }
  }, [item])

  useEffect(() => {
    // start loading original image
    let isMounted = true;
    if (!(imgPathXS == null || !bigLoading.current)) {
      loadImage(imgPathXS, '', false, () => {
        if(isMounted) {
          // if big image was not yet loaded then set xs image
          if (currentSrc == null && bigLoading.current) {
            setCurrentSrc(imgPathXS)
          }
        }
      }, () => {
        if(isMounted) {
          setCurrentSrc(defaultSrc)
        }
      })
    }
    return () => {
      isMounted = false
    } 
  }, [imgPathXS])

  useEffect(() => {
    // start loading original image
    let isMounted = true;
    if (!(imgPath == null || !loading)) {
      loadImage(imgPath, (item?.uuid?.toLowerCase() || '') + `_${size}`, true, () => {
        if(isMounted) {
          bigLoading.current = false
          setLoading(false)
          setCurrentSrc(imgPath)
        }
      }, () => {
        if(isMounted) {
          setCurrentSrc(defaultSrc)
          setLoading(false)
        }
      })
    }
    return () => {
      isMounted = false
    } 
  }, [imgPath])

  return <div className={`image-container ${props.addContainerClass || ''} ${loading ? 'asset-loading' : 'asset-loaded'}`}>{currentSrc ? <img
    src={currentSrc || ''}
    className={`${props.addClass || ''} ${loading ? 'asset-loading' : 'asset-loaded'}`}
    alt={'img'}
    onClick={props.onClick}
  /> : <div className='image-placeholder' />}
  </div>
}

export default React.memo(OEAsset)
